export default __webpack_public_path__ + "assets/671888c1d1239b30920d35f25db0572b.svg";